import { render, staticRenderFns } from "./ContractBtn.vue?vue&type=template&id=b6152ec8&scoped=true"
import script from "./ContractBtn.vue?vue&type=script&lang=js"
export * from "./ContractBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6152ec8",
  null
  
)

export default component.exports